import React from "react";
import cx from "classnames";
import { Container } from "src/components/container";
import { BlockContent } from "src/components/block-content";
import { Media } from "src/components/media";

import { useInView } from "react-intersection-observer";

import { ReactComponent as SustainabilityPageIntroShape } from "src/images/svg/SustainabilityPageIntroShape.svg";

import * as styles from "./intro.module.css";

export interface SustainabilityIntroProps {
	copy: any[];
	finePrint: any[];
	headline: any[];
	media: any;
}

export const SustainabilityIntro = ({
	data,
}: {
	data: SustainabilityIntroProps;
}) => {
	const { copy, finePrint, headline, media } = data;

	const { ref, inView } = useInView({
		threshold: 0.5,
	});

	return (
		<div className={styles.intro} ref={ref}>
			<Container>
				<h1 className="m0 p0">
					<BlockContent
						className={cx("headline ac", styles.headline)}
						blocks={headline}
					/>
				</h1>

				{media && (
					<div className={cx(styles.mediaContainer)}>
						<div className={cx(styles.media)}>
							<SustainabilityPageIntroShape />
							<Media data={media} className={styles.mediaMedia} />
						</div>
					</div>
				)}

				<BlockContent
					className={cx("ac title highlight-em", inView ? "in-view" : "")}
					blocks={copy}
				/>
				<BlockContent
					className={cx("ac body", styles.finePrint)}
					blocks={finePrint}
				/>
			</Container>
		</div>
	);
};
